<template>
  <div class="remoteConsultation">
    <div class="table-info">
      <div class="breadcrumb">
        <span>位置：</span>
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>远程医疗</el-breadcrumb-item> -->
          <el-breadcrumb-item>课程学习</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <h3>课程学习</h3>
    </div>
    <div class="table-content">
      <div class="tool-bar">
        <span>关键字：</span>
        <el-input
          size="small"
          placeholder="请输入"
          width="264"
          class="key-word"
          v-model="keyword"
        ></el-input>
        <span>查房时间：</span>
        <el-date-picker
          v-model="conditionTime"
          width="264"
          type="daterange"
          size="small"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <span>状态：</span>
        <el-select
          v-model="status"
          size="small"
          class="status"
        >
          <el-option
            v-for="item in statusDatas"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button
          type="primary"
          size="small"
          @click="getAllLive()"
          v-if="isCompleted && isShowButton('查询')"
        >查询</el-button>
        <el-button
          size="small"
          @click="reset()"
          v-if="isCompleted && isShowButton('重置')"
        >重置</el-button>
        <el-button
          size="small"
          type="primary"
          @click="openDialog()"
          v-if="isCompleted && isShowButton('课程发布')"
        >课程发布</el-button>
      </div>
      <!-- 课程发布对话框 -->
      <el-dialog
        :title="modalName"
        :visible.sync="courseRelease"
        :before-close="handleClose"
      >
        <el-form
          :model="courseReleaseForm"
          :rules="rules"
          ref="courseReleaseForm"
        >
          <el-row :gutter="3">
            <el-col :span="23">
              <el-form-item
                label="课程标题:"
                :label-width="formLabelWidth"
                prop="title"
              >
                <el-input
                  v-model="courseReleaseForm.title"
                  auto-complete="off"
                  size="small"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="3">
            <el-form-item prop="courseDescription">
              <el-col
                class="conditionTextarea"
                :span="3"
              ><span>课程说明:</span></el-col>
              <el-col :span="20">
                <el-input
                  type="textarea"
                  v-model="courseReleaseForm.courseDescription"
                  rows="3"
                  placeholder="请输入"
                ></el-input>
              </el-col>
            </el-form-item>
          </el-row>
          <el-row :gutter="3">
            <el-col :span="12">
              <el-form-item
                label="授课医院:"
                :label-width="formLabelWidth"
                size="small"
              >
                <el-select
                  v-model="courseReleaseForm.lectureHospitalID"
                  placeholder="请选择"
                  disabled="disabled"
                >
                  <el-option
                    v-for="item in courseReleaseForm.hospitals"
                    :key="item.hospitalId"
                    :label="item.hospitalName"
                    :value="item.hospitalId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="授课医生:"
                :label-width="formLabelWidth"
                size="small"
              >
                <el-select
                  v-model="courseReleaseForm.lectureDoctorID"
                  placeholder="请选择"
                  disabled="disabled"
                >
                  <el-option
                    v-for="item in courseReleaseForm.doctors"
                    :key="item.userId"
                    :label="item.userName"
                    :value="item.userId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item
                label="课程周期:"
                :label-width="formLabelWidth"
                prop="cyde"
              >
                <!-- <el-radio v-model="courseReleaseForm.cyde" label=1 :disabled="isEdit">单次</el-radio>
                <el-radio v-model="courseReleaseForm.cyde" label=2 :disabled="isEdit">每周</el-radio>
                <el-radio v-model="courseReleaseForm.cyde" label=3 :disabled="isEdit">每月</el-radio> -->
                <el-radio-group
                  v-model="courseReleaseForm.cyde"
                  :disabled="isEdit"
                >
                  <el-radio :label="1">单次</el-radio>
                  <el-radio :label="2">每周</el-radio>
                  <el-radio :label="3">每月</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              :span="11"
              :offset="1"
            >
              <el-form-item
                label="首次时间:"
                :label-width="formLabelWidth"
                prop="lectureTime"
              >
                <el-date-picker
                  type="datetime"
                  :picker-options="pickerOptions0"
                  placeholder="选择日期"
                  v-model="courseReleaseForm.lectureTime"
                  style="width: 100%;"
                  size="small"
                  @change="changeLecTime"
                  :disabled="isEdit"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="3">
            <el-col :span="12">
              <el-form-item
                label="医院分组:"
                :label-width="formLabelWidth"
                size="small"
                prop="userGroup"
              >
                <template>
                  <el-radio-group
                    :max="1"
                    v-model="courseReleaseForm.userGroup"
                    @change="changeCheckBox(courseReleaseForm.userGroup)"
                  >
                    <el-radio-button
                      v-for="(item, index) in userGroupList"
                      :key="index"
                      :label="item.groupName"
                      :value="item.id"
                    ></el-radio-button>
                  </el-radio-group>
                </template>
              </el-form-item>

            </el-col>

            <el-col :span="11">
              <el-form-item
                label="对象医院:"
                :label-width="formLabelWidth"
                size="small"
                prop="targetHospitalID"
              >
                <el-select
                  v-model="courseReleaseForm.targetHospitalID"
                  multiple
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in courseReleaseForm.otherHospitals"
                    :key="item.id"
                    :label="item.hospitalName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="3">
            <el-col :span="12">
              <el-form-item
                label="会议室:"
                :label-width="formLabelWidth"
                size="small"
                prop="BoardroomID"
              >
                <el-select
                  v-model="courseReleaseForm.boardroomID"
                  placeholder="请选择"
                  :disabled="isEdit"
                >
                  <el-option
                    v-for="item in courseReleaseForm.conferenceRooms.value"
                    :key="item.hospitalId"
                    :label="item.hospitalName"
                    :value="item.hospitalId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item
                label="结束时间:"
                :label-width="formLabelWidth"
                size="small"
                prop="endTime"
              >
                <el-date-picker
                  :disabled="isEdit"
                  type="datetime"
                  :picker-options="pickerOptions0"
                  placeholder="选择日期"
                  v-model="courseReleaseForm.endTime"
                  style="width: 100%;"
                  size="small"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-row>
            <el-col
              :span="2"
              :offset="17"
            >
              <el-button
                @click="cancel"
                size="small"
              >取 消</el-button>
            </el-col>
            <el-col
              :span="2"
              :offset="2"
            >
              <el-button
                type="primary"
                @click="courseReleaseFormSubmit('courseReleaseForm')"
                size="small"
                :loading="isLoading"
              >确 定</el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
      <!-- 表格 -->
      <el-table
        :data="liveCourse"
        v-loading="loading"
        style="width: 100%"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form
              label-position="left"
              inline
              class="demo-table-expand"
            >
              <el-form-item label="课程介绍:">
                <span>{{ props.row.courseDescription }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="课程标题"
          prop="courseName"
        >
        </el-table-column>
        <el-table-column
          label="授课医院"
          prop="lectureHospitalName"
        >
        </el-table-column>
        <el-table-column
          label="授课医生"
          prop="lectureDoctorName"
        >
        </el-table-column>
        <el-table-column
          label="授课时间"
          prop="lectureTime"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          label="状态"
          prop="status"
        >
        </el-table-column>
        <el-table-column
          label="周期性"
          prop="cycle"
        >
        </el-table-column>
        <el-table-column
          label="发布时间"
          prop="startTime"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          width="200px"
        >
          <template slot-scope="scope">
            <div
              v-for="(item, index) in scope.row.operations"
              :key="index"
            >
              <template v-if="item==='主持'">
                <el-button
                  class="marginRight10"
                  type="text"
                  @click="host(scope.row)"
                >课程主持</el-button>
              </template>
              <template v-if="item==='停止'">
                <el-button
                  class="marginRight10"
                  type="text"
                  @click="isStop( scope.row.id, scope.row.lectureTime, scope.row.cycle)"
                >停止</el-button>
              </template>
              <template v-if="item==='进入'">
                <el-button
                  class="marginRight10"
                  type="text"
                  @click="join(scope.row)"
                >课程直播</el-button>
              </template>
              <template v-if="item === '编辑' ">
                <el-button
                  class="marginRight10"
                  type="text"
                  @click="editLiveCourse(scope.row)"
                >编辑</el-button>
              </template>

              <!-- <template v-if="item === '等待中' ">
                <el-button class="marginRight10" type="text" @click="editLiveCourse(scope.row)">编辑</el-button>
              </template> -->

            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change='handleSizeChange'
        @current-change='handleCurrentChange'
        :current-page.sync='PageIndex'
        :page-sizes='[10, 20, 50]'
        :page-size='PageSize'
        layout='total, sizes, prev, pager, next, jumper'
        :total='total'
      >
      </el-pagination>
      <!--  停止模态框 -->
      <el-dialog
        title="停止"
        :visible.sync="isFalse"
      >
        <el-form
          :model="stopForm"
          :rules="rules"
          ref="stopForm"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="停止理由:" :label-width="formLabelWidth"  prop="reason">
                <el-input v-model="stopForm.reason" auto-complete="off" size="small" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="isDanci">
              <el-form-item
                label="课程周期："
                :label-width="formLabelWidth"
              >
                <el-radio-group v-model="stopForm.radio">
                  <el-radio label="1">单次停止</el-radio>
                  <el-radio label="2">永久性停止</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col v-if="isDanci" :span="24">
              <span
                v-if="stopForm.radio==='1'"
                style="color: red;padding-left: 8px;display:block; margin-top:-20px;"
              >提示：{{stopForm.nextDate}}的查房将会被停止，你可以进行下一次的查房</span>
              <span
                v-else
                style="color: red;padding-left: 8px;display:block; margin-top:-20px;"
              >提示：将会停止所有查房</span>
            </el-col>
          </el-row>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-row>
            <el-col
              :span="2"
              :offset="16"
            >
              <el-button
                @click="isFalse = false"
                size="small"
              >取 消</el-button>
            </el-col>
            <el-col
              :span="2"
              :offset="2"
            >
              <el-button
                type="primary"
                @click="submitStop('stopForm')"
                size="small"
              >确 定</el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import isShowButton from "@/mixins";
export default {
  mixins: [isShowButton],
  data() {
    return {
      loading: true,
      isCompleted: false, //是否请求完成
      btnPremissionList: [],
      menuId: this.$route.query.menuId,

      isLoading: false, //课程发布按钮加载动画
      modalName: "",
      isEdit: false,
      userId: localStorage.getItem("UserId"),
      liveId: "",
      isDanci: true,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      options: {},
      hubUrl: "/api/chatHub",
      // hubUrl: 'http://wh.zkcis.com:8888/chatHub',
      connection: null,
      isFalse: false,
      stopForm: {
        roomId: "",
        radio: "1",
        reason: "",
        nextDate: ""
      },
      isShow: false,
      PageIndex: 1, //当前页
      PageSize: 10, //每页数量
      totalCache: 0, //条数
      status: "",
      statusDatas: [
        { name: "等待中", value: 1 },
        { name: "授课中", value: 2 },
        { name: "已停止", value: 3 },
        { name: "已结束", value: 4 }
      ],
      keyword: "",
      conditionTime: '',
      // 表格
      liveCourse: [],
      // 课程发布弹出框
      userGroupList: [],
      courseRelease: false,
      courseReleaseForm: {
        userGroup: [],
        endTime: "",
        boardroomID: "", //会议室
        lectureDoctorID: "", //授课医生
        lectureHospitalID: "", //授课医院
        targetHospitalID: [], //对象医院
        title: "",
        courseDescription: "", //课程说明
        // 授课医院组
        hospitals: [
          {
            hospitalName: "",
            hospitalId: ""
          }
        ],
        // 授课医生组
        doctors: [
          {
            userName: "",
            userId: ""
          }
        ],
        lectureTime: "", //首次时间
        // 对象医院组
        otherHospitals: [],
        //会议室
        conferenceRooms: [],
        cyde: 1 //课程周期
      },
      formLabelWidth: "90px",
      // 表单验证规则
      rules: {
        lectureDoctorID: [
          {
            required: true,
            message: "请选择授课医生",
            trigger: "change"
          }
        ],
        lectureHospitalID: [
          {
            required: true,
            message: "请选择授课医院",
            trigger: "change"
          }
        ],
        targetHospitalID: [
          {
            required: true,
            message: "请选择对象医院",
            trigger: "change"
          }
        ],
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "change"
          },
          { max: 20, message: "标题长度不能超过20个字符串" }
        ],
        courseDescription: [
          {
            required: true,
            message: "请输入课程说明",
            trigger: "change"
          },
          { max: 100, message: "不能超过100个字符串" }
        ],
        boardroomID: [
          {
            required: true,
            message: "请选择会议室",
            trigger: "blur"
          }
        ],
        lectureTime: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        reason: [
          {
            required: true,
            message: "请输入停止原因",
            trigger: "blur"
          },
          { max: 100, message: "不能超过100个字符串" }
        ],
        cyde: [
          {
            required: true,
            message: "请选择课程周期",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    cancel() {
      this.$confirm("关闭后信息不能保存,是否退出？")
        .then(_ => {
          this.courseRelease = false
        })
        .catch(_ => {});
      this.$refs["courseReleaseForm"].resetFields();
    },
    // 根据医院分组获取分组下面的所有医院
    changeUserGroup(id) {
      // console.log(id == '')
      if (id == "") {
        this.courseReleaseForm.targetHospitalID = [];
      }
      this.Axios.get(
        "/api/GroupHospital/GetGroupHospitalInfoById?id=" + id
      ).then(res => {
        // console.log(res.data)
        const data = res.data;
        let arr = [];
        if (data.status === 100) {
          for (let item of data.data) {
            arr.push(item.id);
          }
          this.courseReleaseForm.targetHospitalID = arr;
        } else if (data.status == 201) {
        } else {
          this.$message({
            showClose: true,
            message: "获取数据失败,请重试!",
            type: "error"
          });
        }
      });
    },
    // 选择用户分组
    changeCheckBox(groupName) {
      // console.log(this.courseReleaseForm.userGroup)
      // console.log(this.userGroupList)
      let id;
      for (let item of this.userGroupList) {
        if (item.groupName == groupName) {
          id = item.id;
        }
      }
      if (id != undefined) {
        this.Axios.get(
          "/api/GroupHospital/GetGroupHospitalInfoById?id=" + id
        ).then(res => {
          // console.log(res.data)
          const data = res.data;
          let arr = [];
          if (data.status === 100) {
            for (let item of data.data) {
              arr.push(item.id);
            }
            this.courseReleaseForm.targetHospitalID = arr;
          } else if (data.status == 201) {
          } else {
            this.$message({
              showClose: true,
              message: "获取数据失败,请重试!",
              type: "error"
            });
          }
        });
      } else {
        this.courseReleaseForm.targetHospitalID = [];
      }
    },
    // 获取所有医院分组
    getAllGroup(pageindex, pagesize) {
      let arr = [];
      this.Axios.get(
        "/api/GroupHospital/GetGroupHospitalList?pageindex=" +
          pageindex +
          "&pagesize=" +
          pagesize
      ).then(res => {
        // console.log(res.data)
        const data = res.data;
        if (data.status === 100) {
          // return arr.push.apply(arr, data.data)
          // // const objHospital = await getHospital()
          // // console.log(objHospital)
          this.userGroupList = data.data;
        } else {
          this.$message({
            showClose: true,
            message: "请求失败,请重新刷新!",
            type: "error"
          });
        }
      });
    },
    // 根据授课时间 往后推迟30分钟得到结束时间
    changeLecTime() {
      let lectureObj = new Date(this.courseReleaseForm.lectureTime);
      let letcureMs = lectureObj.getTime();
      let endMs = letcureMs + 1800000;
      let endObj = new Date(endMs);
      this.courseReleaseForm.endTime = endObj;
    },
    // 编辑课程
    editLiveCourse(val) {
      this.openDialog();
      this.modalName = "编辑课程";
      this.courseRelease = true;
      this.isEdit = true;
      this.Axios.get("/api/LiveCourse/GetInfosByID?liveID=" + val.id).then(
        res => {
          //获取对象医院
          const data = res.data;
          if (data.status === 100) {
            this.courseReleaseForm.title = data.data.courseName;
            this.courseReleaseForm.courseDescription =
              data.data.courseDescription;
            this.courseReleaseForm.cyde = data.data.cycle;
            this.courseReleaseForm.lectureTime = new Date(data.data.lectureTime);
            this.courseReleaseForm.endTime = data.data.endTime;
            this.courseReleaseForm.boardroomID = data.data.boardroomID;
            this.courseReleaseForm.id = data.data.id;
            this.courseReleaseForm.targetHospitalID =
              data.data.targetHospitalID;
          }
        }
      );
    },
    handleClose(done) {
      this.$confirm("关闭后信息不能保存,是否退出？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
      this.$refs["courseReleaseForm"].resetFields();
    },
    //停止
    isStop(id, date, isCycle) {
      this.isFalse = true;
      this.stopForm.roomId = id;
      this.stopForm.nextDate = date;
      isCycle == '单次' ? this.isDanci = false : this.isDanci = true
    },
    //执行停止的操作
    submitStop(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.isDanci) {
            this.stopForm.radio = '2'
          }
          this.Axios.put(
            "/api/LiveCourse/StopLiveCourse/" +
              this.stopForm.roomId +
              "," +
              parseInt(this.stopForm.radio) + ',' + this.stopForm.reason
          ).then(res => {
            if (res.data.status == 100) {
              this.$message({
                showClose: true,
                message: res.data.message,
                type: "success"
              });
              this.getAllLive();
              this.isFalse = false;
            } else {
              this.$message({
                showClose: true,
                message: '操作失败!',
                type: "error"
              });
            }
          });
        }
      });
    },
    // 进入
    join(val) {
      // 把会诊时间转为日期对象
      let dateObj = new Date(val.lectureTime);
      //把会诊时间转为时间戳
      let dateStamp = Date.parse(dateObj);
      //获取当前时间
      let currentDate = new Date();
      let currentStamp = Date.parse(currentDate);
      if (dateStamp - currentStamp > 1200000) {
        this.$message({
          showClose: true,
          message: "直播前二十分钟才能进入",
          type: "error"
        });
      } else {
        this.Axios.get(`/api/LiveCourse/GetZhuMuAgreement?ID=${val.id}&type=3`).then(res => {
          const data = res.data
          if (data.status === 100) {
            window.open(data.data, '_self')
            this.Axios.get(`/api/Boardroom/JoinInfos?mid=${val.id}&type=3`).then(res => {
            })
            this.getAllLive()
          } else {
            this.$message.warning(data.message)
          }
        }).catch(() => {
          this.$message.error('网络错误，请联系管理员！')
        })
        // this.Axios.get("/api/LiveCourse/GetJoinUrl").then(res => {
        //   const data = res.data;
        //   if (data.status === 100) {
        //     let url = val.joinUrl + "?zpk=" + data.data;
        //     window.open(url);
        //     this.Axios.get(
        //       "/api/Boardroom/JoinInfos?mid=" + val.id + "&type=3"
        //     ).then(res => {
        //       // console.log("进入", res.data);
        //     });
        //   } else if (data.status === 200) {
        //     this.$message({
        //       showClose: true,
        //       message: "未查询到账号信息!",
        //       type: "error"
        //     });
        //   }
        // });
        // this.getAllLive();
      }
    },
    // 主持
    host(val) {
      //主持
      // 把会诊时间转为日期对象
      let dateObj = new Date(val.lectureTime);
      //把会诊时间转为时间戳
      let dateStamp = Date.parse(dateObj);
      //获取当前时间
      let currentDate = new Date();
      let currentStamp = Date.parse(currentDate);
      if (dateStamp - currentStamp > 1200000) {
        this.$message({
          showClose: true,
          message: "直播前二十分钟才能开始进行",
          type: "error"
        });
      } else {
        this.Axios.get(`/api/LiveCourse/GetZhuMuAgreement?ID=${val.id}&type=3`).then(res => {
          const data = res.data
          if (data.status === 100) {
            window.open(data.data, '_self')
            this.getAllLive()
          } else {
            this.$message.warning(data.message)
          }
        }).catch(() => {
          this.$message.error('网络错误，请联系管理员！')
        })
        // this.Axios.get(
        //   "/api/LiveCourse/RefreshStartUrl?ID=" + val.id + "&type=1"
        // ).then(res => {
        //   const data = res.data;
        //   if (data.status === 100) {
        //     window.open(data.startUrl);
        //     this.getAllLive();
        //   } else if (data.status === 200) {
        //     this.$message({
        //       showClose: true,
        //       message: "内部异常联系管理员!",
        //       type: "error"
        //     });
        //   } else if (data.code === 103) {
        //     this.$message({
        //       showClose: true,
        //       message: "cookie过期,请重新登录!",
        //       type: "error"
        //     });
        //   } else {
        //     this.$message({
        //       showClose: true,
        //       message: "内部异常联系管理员!",
        //       type: "error"
        //     });
        //   }
        // });
      }
    },
    openDialog() {
      this.getAllGroup(1, 200);
      this.modalName = "课程发布";
      this.isEdit = false;
      this.courseReleaseForm.title = "";
      this.courseReleaseForm.courseDescription = "";
      // 对象医院id
      this.courseReleaseForm.targetHospitalID = [
        window.localStorage.getItem("HospitalID")
      ];
      this.courseReleaseForm.boardroomID = "";
      this.courseReleaseForm.lectureTime = "";
      this.courseReleaseForm.otherHospitals = [];
      // 当前登录用户属于哪家医院
      this.Axios.get("/api/Hospital/GetAllHospital").then(res => {
        //获取对象医院
        if (res.data.status === 100) {
          // console.log(res.data.data)
          // 对象医院
          this.courseReleaseForm.otherHospitals = res.data.data;
          let obj = {
            hospitalName: window.localStorage.getItem("HospitalName"),
            id: window.localStorage.getItem("HospitalID")
          };
          this.courseReleaseForm.otherHospitals.unshift(obj);
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: "error"
          });
        }
      });
      this.Axios.get("/api/User/GetUserInfo").then(res => {
        if (res.data.status === 100) {
          // 授课医院名字
          this.courseReleaseForm.hospitals[0].hospitalName =
            res.data.ret.hospitalName;
          // 授课医院id
          this.courseReleaseForm.hospitals[0].hospitalId =
            res.data.ret.hospitalId;
          this.courseReleaseForm.lectureHospitalID = res.data.ret.hospitalId;
          this.courseReleaseForm.doctors[0].userName = res.data.ret.userName;
          this.courseReleaseForm.doctors[0].userId = res.data.ret.userId;
          this.courseReleaseForm.lectureDoctorID = res.data.ret.userId;
          this.courseReleaseForm.conferenceRooms = res.data.ret.boardroom;
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: "error"
          });
        }
      });
      this.courseRelease = true;
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.getAllLive();
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.getAllLive();
    },
    // 重置搜索关键词及状态
    reset() {
      this.keyword = "";
      this.status = "";
      this.conditionTime = ''
      this.getAllLive();
      this.$route.query.id = "";
    },
    // 课程发布表单提交
    courseReleaseFormSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid && this.modalName == "课程发布") {
          this.isLoading = true
          this.courseRelease = true
          const conditions = {
            courseName: this.courseReleaseForm.title,
            lectureHospitalID: this.courseReleaseForm.lectureHospitalID,
            lectureDoctorID: this.courseReleaseForm.lectureDoctorID,
            lectureTime: this.courseReleaseForm.lectureTime,
            status: 1,
            courseDescription: this.courseReleaseForm.courseDescription,
            cycle: parseInt(this.courseReleaseForm.cyde),
            targetHospitalID: this.courseReleaseForm.targetHospitalID,
            boardroomID: this.courseReleaseForm.boardroomID,
            endTime: this.courseReleaseForm.endTime
          };
          let startTime = moment(this.courseReleaseForm.lectureTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          if (this.courseReleaseForm.boardroomID == '') {
            this.$message({
              showClose: true,
              message:"没有会议室的医院不能发布课程!",
              type: "error"
            });
            this.isLoading = false
            this.courseRelease = true
            return
          }
          // console.log('课程发布会议室', conditions.boardroomID)
          this.Axios.get(
            "/api/User/JudgeBoardroomInfo?time=" +
              startTime +
              "&boardroomId=" +
              this.courseReleaseForm.boardroomID
          ).then(res => {
            if (res.data.flag && res.data.status === 100) {
              this.$confirm("次会议时时间段有冲突，是否继续？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  this.Axios.post(
                    "/api/LiveCourse/AddLiveCourse",
                    conditions
                  ).then(res => {
                    if (res.data.status === 100) {
                      this.$message({
                        showClose: true,
                        message: "添加成功!",
                        type: "success"
                      });
                      this.$refs[formName].resetFields();
                      this.getAllLive();
                      this.courseRelease = false;
                    } else {
                      this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: "error"
                      });
                      this.courseRelease = true;
                    }
                    this.isLoading = false
                    this.$refs[formName].resetFields();
                  });
                })
                .catch(() => {
                  this.isLoading = false
                  this.$message({
                    type: "info",
                    message: "已取消"
                  });
                });
            } else if (!res.data.flag && res.data.status === 100) {
              this.Axios.post("/api/LiveCourse/AddLiveCourse", conditions).then(
                res => {
                  // console.log("aaa",res)
                  if (res.data.status === 100) {
                    this.$message({
                      showClose: true,
                      message: "添加成功!",
                      type: "success"
                    });
                    this.getAllLive();
                    this.courseRelease = false;
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.data.message,
                      type: "error"
                    })
                    this.courseRelease = true
                  }
                  this.isLoading = false
                }
              );
            } else {
              this.isLoading = false
              this.$message({
                showClose: true,
                message: "内部异常联系管理员!",
                type: "error"
              });
            }
          });
        } else if (valid && this.modalName == "编辑课程") {
          this.isLoading = true
          this.courseRelease = true
          const conditions = {
            courseName: this.courseReleaseForm.title,
            courseDescription: this.courseReleaseForm.courseDescription,
            targetHospitalID: this.courseReleaseForm.targetHospitalID
          };
          // console.log(typeof conditions.lectureTime);
          this.Axios.put(
            "/api/LiveCourse/UpdateLiveCourse?id=" + this.courseReleaseForm.id,
            conditions
          ).then(res => {
            // console.log("aaa", res.data);
            const data = res.data;
            if (data.status === 100) {
              this.$message({
                showClose: true,
                message: "修改成功!",
                type: "success"
              });
              this.courseRelease = false;
              this.getAllLive();
            } else {
              this.$message({
                showClose: true,
                message: "修改失败!",
                type: "error"
              });
              this.courseRelease = true;
            }
            this.isLoading = false
          });
        } else {
          this.courseRelease = true;
          return false;
        }
      });
    },
    getAllLiveById() {
      this.loading = true
      this.Axios.get("/api/Remote/HomeJump?id=" + this.liveId + "&type=" + 3)
        .then(res => {
          if (res.status === 200) {
            this.liveCourse = res.data.data;
            this.totalCache = res.data.total;
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error"
            });
          }
          this.loading = false
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: "网络错误，联系管理员",
            type: "error"
          });
        });
    },
    jumpGetLiveById(liveID) {
      this.loading = true
      this.Axios.get("/api/Remote/HomeJump?id=" + liveID + "&type=" + 3)
        .then(res => {
          // console.log(res)
          if (res.status === 200) {
            // console.log('jump', res.data)
            this.liveCourse = res.data.data
            // this.totalCache = res.data.total
            // console.log('live', res.data.total)
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error"
            });
          }
          this.loading = false
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: "网络错误，联系管理员",
            type: "error"
          });
        });
    },
    //获取直播课程列表
    getAllLive() {
      const conditions = {
        start: this.PageIndex,
        pagesize: this.PageSize
      };
      if (this.status != "") {
        conditions.status = this.status;
      }
      if (this.keyword != "") {
        conditions.keyword = this.keyword;
      }

      if (this.conditionTime && this.conditionTime.length === 2) {
        conditions.time = `${moment(this.conditionTime[0]).format('YYYY-MM-DD HH:mm:ss')},${moment(this.conditionTime[1]).format('YYYY-MM-DD 23:59:59')}`
      }
      this.loading = true
      this.Axios.get("/api/LiveCourse/SearchLiveCourse", { params: conditions })
        .then(res => {
          if (res.status === 200) {
            // console.log("直播课程", res.data.data);
            this.liveCourse = res.data.data;
            this.totalCache = res.data.total;
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error"
            });
          }
          this.loading = false
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "网络错误，联系管理员",
            type: "error"
          });
        });
    }
  },
  computed: {
    total() {
      return this.totalCache;
    }
  },
  mounted() {
    // this.Axios.get("/api/LiveCourse/IsHaveBoardroom")
    //   .then(res => {
    //     let data = res.data;
    //     // console.log(data);
    //     if (data.status == 100 && data.flag) {
    //       this.isShow = data.flag;
    //       // this.dialogShow = data.flag
    //     }
    //   })
    //   .catch(error => {
    //     this.$message({
    //       showClose: true,
    //       message: "网络错误，联系管理员",
    //       type: "error"
    //     });
    //   });

    //   this.options.transport=signalR.HttpTransportType["LongPolling"]
    //   this.connection = new signalR.HubConnectionBuilder().withUrl(this.hubUrl).build();
    //   this.connection.start(signalR.TransferFormat.Text)
    //  /* this.connection.on("RefreshForm", ()=> {
    //     this.getAllLive()
    //   })*/
    //   this.connection.on("RefreshCallbackForm", ()=> {
    //     this.getAllLive()
    //   })
    //   this.connection.onclose(()=>{
    //     this.connection.start(signalR.TransferFormat.Text).catch((err)=>{
    //       return console.log("链接又失败了")
    //     })
    //   })
    if (this.$route.query.id == undefined || this.$route.query.id == '') {
      this.getBtnRole()
    }

    if (this.$route.query.id != undefined && this.$route.query.id != "") {
      this.liveId = this.$route.query.id;
      this.getAllLiveById();

      // const liveId = this.$route.query.id;
      // this.jumpGetLiveById(liveId)
    } else {
      this.getAllLive();
    }
    this.liveId = "";
  }
};

</script>

<style scoped lang="less">
.remoteConsultation {
  .el-table td div {
    display: inline;
  }
  .breadcrumb {
    overflow: hidden;
    span,
    .el-breadcrumb {
      float: left;
    }
    span {
      font-size: 14px;
      color: #666;
      line-height: 1;
    }
  }
  .table-content {
    .tool-bar {
      padding: 0 20px;
      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
      }
      .key-word,
      .status {
        width: 264px;
        margin-right: 40px;
      }
    }
    .el-table {
      margin: 20px 0px;
    }
    .el-pagination {
      /deep/ .number {
        background: #fff;
      }
    }
    .pageSize {
      margin-top: 25px;
    }
    .conditionTextarea {
      width: 70px;
      height: 60px;
      line-height: 24px !important;
      text-align: right;
      margin-right: 8px;
    }
    .consent {
      padding-left: 10px;
    }
    .uploadBtn {
      margin-right: 10px;
    }
    .el-icon-upload2 {
      font-size: 14px;
      margin-right: 5px;
    }
    .el-icon-download {
      font-size: 20px;
    }
    .el-dialog__wrapper {
      /deep/ .el-dialog__header {
        border-bottom: 1px solid #d9d9d9;
      }
      /deep/ .el-dialog__footer {
        border-top: 1px solid #d9d9d9;
      }
    }
    .el-popover__reference {
      margin-right: 10px;
    }
  }
  .el-dialog__wrapper {
    /deep/ .el-dialog__header {
      border-bottom: 1px solid #d9d9d9;
    }
    /deep/ .el-dialog__footer {
      border-top: 1px solid #d9d9d9;
    }
    /deep/ .el-dialog__title {
      font-size: 14px;
    }

    /deep/ .el-dialog {
      width: 770px;
    }
    /deep/ .el-input--suffix {
      width: 254px;
    }
    /deep/ .el-textarea__inner {
      width: 620px;
    }
    .uploadBtn {
      margin-right: 10px;
    }
    .consent {
      padding-left: 10px;
    }
    .conditionTextarea {
      width: 70px;
      height: 60px;
      line-height: 24px !important;
      text-align: right;
      margin-right: 8px;
    }
    .el-select {
      width: 224px;
    }
    .el-textarea {
      width: 557px;
    }
  }
  /deep/ .el-form-item.is-required .el-form-item__label:before {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/RemoteMedical/LiveCourse.vue